import { InvestmentTransaction, TransactionTypes, TransactionSource } from '../../../types/investmentApi.types'
import { convertEpochToDate, fixedDigitsAndFormatNumberWithCurrency } from '../../../../../utils/utils'
import { mfLogoBaseUrl } from '../../../../../env'
import RenderHTML from '../../../../../components/ui-components/RenderHTML'

type TransactionPropTypes = {
  transaction: InvestmentTransaction
  fundLogo: string
  fundName: string
  isFirst?: boolean
  isLast?: boolean
}

const getTransactionTypeText = (type: `${TransactionTypes}`) => {
  switch (type) {
    case TransactionTypes.BUY:
      return 'One-time'
    case TransactionTypes.SELL:
      return 'Withdraw'
    case TransactionTypes.SIP:
      return 'SIP'
    default:
      return ''
  }
}
export default function TransactionRowV2({ transaction, isFirst, isLast, fundLogo, fundName }: TransactionPropTypes) {
  return (
    <div className={`flex gap-4 ${isFirst ? '' : 'pt-3'} items-center`}>
      <div>
        {/* image */}
        <div className='w-max h-max overflow-hidden'>
          <img src={`${mfLogoBaseUrl}${fundLogo}`} className='h-10 w-10' />
        </div>
      </div>
      <div className={`flex w-1 flex-1 border-b border-[#EBF2F2] pb-4 ${isLast ? 'border-b-0' : ''}`}>
        {/* fund name and transaction amount */}
        <div className='flex flex-col gap-1 w-1 flex-1 pr-1'>
          <div className='flex items-center gap-1 pt-1'>
            {transaction?.source === TransactionSource.EXTERNAL && (
              <>
                <div>
                  <RenderHTML innerHTMLText={ExternalIcon} />
                </div>
                <div className='text-[12px] font-[400] text-[#8E9393]'>External</div>
              </>
            )}
            {transaction?.source === TransactionSource.POWER_UP && (
              <>
                <div>
                  <RenderHTML innerHTMLText={PowerUpIcon} />
                </div>
                <div className='text-[12px] font-[400] text-[#8E9393]'>PowerUp</div>
              </>
            )}
            {transaction?.source === TransactionSource.INFINITE && (
              <div className='text-[12px] font-[400] text-[#8E9393]'>Infinite</div>
            )}
          </div>
          <div className='max-w-[98%] truncate text-[13px] font-[400] text-[#6A6E6E]'>{fundName ?? ''}</div>
          <div className='flex gap-2'>
            <div className='text-black font-[500] text-[18px] leading-[130%]'>
              {fixedDigitsAndFormatNumberWithCurrency(transaction?.txnAmount?.amount, 2)}
            </div>
            {getTransactionTypeText(transaction?.type) && (
              <div
                className={`rounded-[8px] px-[6px] min-w-[30px] h-[21px] text-[12px] text-[#3D3D3D] font-[500] 
                  flex items-center justify-center border border-[#EBF2F2] mt-[1px]`}
              >
                {getTransactionTypeText(transaction?.type)}
              </div>
            )}
          </div>
        </div>
        {/* timestamp */}
        <div className={`text-[13px] font-[400] text-[#8E9393] pr-5 pt-[25.5px]`}>
          {convertEpochToDate(transaction?.timestamp ?? Date.now(), '%_d %b %Y')}
        </div>
      </div>
    </div>
  )
}

const ExternalIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <rect width="12" height="12" fill="white"/>
  <path d="M2.99969 2.5H8.9997V8.5" stroke="#8E9393" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.99951 2.5L1.99951 9.5" stroke="#8E9393" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`

const PowerUpIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <rect width="12" height="12" fill="white"/>
  <path d="M9.10712 4.83461H5.99997V0.950684L0.950867 7.16497H4.4464V11.0489L9.10712 4.83461Z" stroke="#8E9393" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
